<template>
  <div>
    <CRow>
      <CCol col="12">
        <CCard>
          <CCardHeader>
            <strong>آموزش و راهنما</strong>

          </CCardHeader>
        </CCard>

        <CRow>
          <CCol col="6 col-sm-3 p-2" v-for="(video,index) in videos" :key="'video-'+index">
            <CCard>
              <CCardBody>

                <div style="display: grid;justify-content: center" @click="show_video(video.source,video.name)">
                  <img src="/img/placeholder.png" height="100px"/>
                  <div class="text-center" >{{ video.name }}</div>
                  <CButton color="dark">نمایش</CButton>
                </div>
              </CCardBody>

            </CCard>

          </CCol>

        </CRow>


      </CCol>
    </CRow>
    <CModal
        :show.sync="video_modal"
        color="transparent"
        :title="video_title"
        size="lg"
        border-color="primary"
    >
      <div>
        <video
            controls
            v-if="video_modal"
            width="100%" height="100%" :src="video_source">
          <source :src="video_source">
        </video>
      </div>


      <template #footer>
        <CButton @click="video_modal=false" color="primary">بستن</CButton>
      </template>
    </CModal>


  </div>

</template>

<script>
import axios from "axios";

import {bus} from '../../main';


export default {
  name: 'Login',
  data() {
    return {
      video_modal: false,
      video_title: '',
      video_source: '',
      videos: [
        {
          name: 'داشبورد',
          source: 'dashboard'
        }, {
          name: 'اعضا',
          source: 'users'
        }, {
          name: 'لاین',
          source: 'lines'
        }, {
          name: 'خدمات',
          source: 'services'
        }, {
          name: 'وقت های رزرو من',
          source: 'mytimes'
        }, {
          name: 'مشتریان من',
          source: 'mycustomers'
        },
        {
          name: 'مالی - تنظیمات',
          source: 'bank'
        }, {
          name: 'مالی - تراکنش ها',
          source: 'transactions'
        }, {
          name: 'جشنواره و هدایا',
          source: 'promotions'
        }, {
          name: 'نمونه کار ها',
          source: 'portfolio'
        }, {
          name: 'اعلانات - تنظیمات',
          source: 'settings'
        },
      ]
    }
  }, mounted() {

  }, watch: {},
  methods: {
    show_video(video, title) {
      this.video_title = title
      this.video_source = 'https://panel.rezerveto.ir/learning/' + video + ".mp4"
      this.video_modal = true

    }
  }
}


</script>
